import * as api from './index';
const t = '/groups';

export default {
  get: api.get(t),
  create: api.post(t),
  update: api.put(`${t}/:id`),
  del: api.del(`${t}/:id`)
};